import * as React from "react"

import { cn } from '@sourcepilot/ui/framework/data/utils'

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  const minHeight = props.style?.minHeight || "80px";
  const rows = props.rows || 2;
  return (
    <textarea
      className={cn(
        `flex min-h-[${minHeight}] w-full rounded-[4px] border border-gray-800 bg-background px-3 py-2 
        text-base ring-offset-background placeholder:text-muted-foreground 
        focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring 
        focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 
        md:text-sm`,
        className
      )}
      rows={rows}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
